import StartMiningWith from './StartMiningWith';

export default StartMiningWith;
